/**
 * Regex to check pec field
 * @type {RegExp}
 */

const pec = /^[a-zA-Z0-9-_+]{1}[a-zA-Z0-9-_.+]{0,62}[a-zA-Z0-9-_+]{1}@[a-zA-Z0-9-.]{1,128}[.]{1}[a-zA-Z]{2,60}$/

export default pec
